import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Tabs, TabsList, TabsTrigger } from '../components/ui/tabs';
import Header from '../components/Header';
import { ScrollArea } from '../components/ui/scroll-area';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../components/ui/tooltip';
import {
  Search, Settings, Palette, Clock, Bell, Link, MessageSquare,
  ArrowLeft,
  AlignJustify,
  ChevronDown,
  ChevronRight,
  Building,
  User,
  Shuffle,
  SunMoon,
  Upload,
  CalendarClock,
  ClockPlus,
  Files,
  MonitorCog,
  Mail,
  BellRing,
  Webhook,
  Workflow,
  Contact,
  Tag,
  Zap,
  Database,
  Layers,
  Timer,
  Tv,
  Facebook,
  History,
  HardDrive,
  ShieldAlert
} from 'lucide-react';
import FormConfiguracoes from '../components/FormConfiguracoes';
import api from '../services/api';
import { authService } from '../services/authService';

type ConfigCategory = 'general' | 'appearance' | 'business-hours' | 'chat' | 'notifications' | 'integrations' | 'tenants' | 'users' | 'queues' | 'instances' | 'n8n' | 'zpro' | 'files' | 'theme' | 'colors' | 'logo' | 'business-days' | 'business-hours' | 'notifications-sounds' | 'notifications-desktop' | 'notifications-email' | 'configurations' | 'contacts' | 'tags' | 'mensagens-rapidas' | 'superadmin' | 'meta-provider-config' | 'retencao-midias' | 'exclusao-dados' | 'meta-config' | 'disparo-automatico' | 'disparo-em-bloco' | 'session' | 'painel-tv';

interface CategoryItem {
  id: ConfigCategory;
  label: string;
  icon: React.ElementType;
  color: string;
  roles?: string[];
  subcategories: { id: ConfigCategory; label: string; icon: React.ElementType; color: string; parent?: ConfigCategory; roles?: string[] }[];
}

const Configuracoes = () => {
  const user = authService.getCurrentUser();
  const navigate = useNavigate();
  const { t } = useTranslation();
  console.log('[CONFIG] MONTOU. userRole=', user?.role, 'userName=', user?.nome);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState<CategoryItem>({} as CategoryItem);
  console.log('[CONFIG] Estado inicial activeTab.id=', ({} as CategoryItem).id, '| activeTab vazio:', Object.keys({} as CategoryItem).length === 0);

  useEffect(() => {
    console.log('[CONFIG] activeTab MUDOU:', { id: activeTab?.id, label: activeTab?.label, keys: Object.keys(activeTab) });
  }, [activeTab]);
  // No celular o menu começa recolhido (só ícones) e, ao expandir, fica sobreposto ao conteúdo
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
  const collapsed = sidebarCollapsed;
  const [expanded, setExpanded] = useState<string | null>(null);
  const categories: CategoryItem[] = [
    {
      id: 'general', color: 'green', label: t('settings.categories.general'), icon: Settings, roles: ['SuperAdmin', 'Admin'],
      subcategories: [
        { id: 'tenants', label: t('settings.categories.tenants'), icon: Building, color: 'green', parent: 'general', roles: ['SuperAdmin'] },
        { id: 'queues', label: t('settings.categories.queues'), icon: Shuffle, color: 'green', parent: 'general', roles: ['SuperAdmin', 'Admin'] },
        { id: 'users', label: t('settings.categories.users'), icon: User, color: 'green', parent: 'general', roles: ['SuperAdmin', 'Admin'] },
        { id: 'session', label: t('settings.categories.session'), icon: Timer, color: 'green', parent: 'general', roles: ['SuperAdmin', 'Admin'] },
        { id: 'painel-tv', label: t('settings.categories.tvPanel'), icon: Tv, color: 'green', parent: 'general', roles: ['SuperAdmin', 'Admin'] },
      ]
    },
    {
      id: 'chat', color: 'red', label: t('settings.categories.chat'), icon: MessageSquare, roles: ['SuperAdmin', 'Admin', 'User'],
      subcategories: [
        { id: 'contacts', label: t('settings.categories.contacts'), icon: Contact, color: 'red', parent: 'chat', roles: ['SuperAdmin', 'Admin', 'User'] },
        { id: 'tags', label: t('settings.categories.tags'), icon: Tag, color: 'red', parent: 'chat', roles: ['SuperAdmin', 'Admin', 'User'] },
        { id: 'mensagens-rapidas', label: t('settings.categories.quickMessages'), icon: Zap, color: 'red', parent: 'chat', roles: ['SuperAdmin', 'Admin', 'User'] },
        { id: 'disparo-em-bloco', label: t('settings.categories.bulkDispatch'), icon: Layers, color: 'red', parent: 'chat', roles: ['SuperAdmin', 'Admin', 'User'] },
        { id: 'disparo-automatico', label: t('settings.categories.automaticDispatch'), icon: CalendarClock, color: 'red', parent: 'chat', roles: ['SuperAdmin', 'Admin', 'User'] },
        // { id: 'files', label: 'Arquivos', icon: Files, color: 'red', parent: 'chat', roles: ['SuperAdmin', 'Admin', 'User'] },
        { id: 'configurations', label: t('settings.categories.configurations'), icon: MonitorCog, color: 'red', parent: 'chat', roles: ['SuperAdmin', 'Admin'] },
      ]
    },
    // {
    //   id: 'appearance', color: 'blue', label: 'Aparência', icon: Palette, roles: ['SuperAdmin', 'Admin'],
    //   subcategories: [
    //     { id: 'theme', label: 'Tema', icon: SunMoon, color: 'blue', parent: 'appearance', roles: ['SuperAdmin', 'Admin'] },
    //     { id: 'colors', label: 'Cores', icon: Palette, color: 'blue', parent: 'appearance', roles: ['SuperAdmin', 'Admin'] },
    //     { id: 'logo', label: 'Logo', icon: Upload, color: 'blue', parent: 'appearance', roles: ['SuperAdmin', 'Admin'] },
    //   ]
    // },
    {
      id: 'business-hours', color: 'yellow', label: t('settings.categories.businessHours'), icon: Clock, roles: ['SuperAdmin', 'Admin'],
      subcategories: [
        { id: 'business-hours', label: t('settings.categories.businessHoursDetail'), icon: ClockPlus, color: 'yellow', parent: 'business-hours', roles: ['SuperAdmin', 'Admin'] },
      ]
    },
    // {
    //   id: 'notifications', color: 'purple', label: 'Notificações', icon: Bell, roles: ['SuperAdmin', 'Admin', 'User'],
    //   subcategories: [
    //     { id: 'notifications-sounds', label: 'Som', icon: BellRing, color: 'purple', parent: 'notifications', roles: ['SuperAdmin', 'Admin', 'User'] },
    //     { id: 'notifications-desktop', label: 'Desktop', icon: MonitorCog, color: 'purple', parent: 'notifications', roles: ['SuperAdmin', 'Admin'] },
    //     { id: 'notifications-email', label: 'Email', icon: Mail, color: 'purple', parent: 'notifications', roles: ['SuperAdmin', 'Admin'] }
    //   ]
    // },
    {
      id: 'integrations', color: 'orange', label: t('settings.categories.integrations'), icon: Link, roles: ['SuperAdmin', 'Admin'],
      subcategories: [
        { id: 'instances', label: t('settings.categories.instances'), icon: Webhook, color: 'orange', parent: 'integrations', roles: ['SuperAdmin', 'Admin'] },
        { id: 'meta-config', label: 'WhatsApp / Meta', icon: Facebook, color: 'orange', parent: 'integrations', roles: ['SuperAdmin'] },
        { id: 'n8n', label: t('settings.categories.n8n'), icon: Workflow, color: 'orange', parent: 'integrations', roles: ['SuperAdmin', 'Admin'] },
        { id: 'zpro', label: 'Histórico Zpro', icon: History, color: 'orange', parent: 'integrations', roles: ['SuperAdmin', 'Admin'] },
      ]
    },
    {
      id: 'superadmin', color: 'red', label: t('settings.categories.superadmin'), icon: Database, roles: ['SuperAdmin'],
      subcategories: [
        { id: 'superadmin', label: t('settings.categories.sqlQueries'), icon: Database, color: 'red', parent: 'superadmin', roles: ['SuperAdmin'] },
        { id: 'meta-provider-config', label: 'Facebook / Meta', icon: Facebook, color: 'red', parent: 'superadmin', roles: ['SuperAdmin'] },
        { id: 'retencao-midias', label: 'Retenção de mídias', icon: HardDrive, color: 'red', parent: 'superadmin', roles: ['SuperAdmin'] },
        { id: 'exclusao-dados', label: 'Exclusão de dados', icon: ShieldAlert, color: 'red', parent: 'superadmin', roles: ['SuperAdmin'] },
      ]
    },
  ];

  let categoriesUser = categories.filter(category => {
    return category.roles?.includes(user?.role);
  });

  categoriesUser = categoriesUser.map(category => {
    return {
      ...category,
      subcategories: category.subcategories.filter(subcategory => {
        return subcategory.roles?.includes(user?.role);
      })
    };
  });

  const [filteredCategories, setFilteredCategories] = useState<CategoryItem[]>(categoriesUser);

  useEffect(() => {
    const filteredCategories = categoriesUser.filter(category => {
      return (
        category.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        category.subcategories.some(subcategory => subcategory.label.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    });
    setFilteredCategories(filteredCategories);
  }, [searchTerm]);

  // Fecha o menu sobreposto no celular depois de escolher uma opção
  const handleSelect = (subcategory: CategoryItem) => {
    setActiveTab(subcategory);
    if (window.matchMedia('(max-width: 767px)').matches) setSidebarCollapsed(true);
  };

  return (
    <div className="flex flex-col md:flex-row h-[100dvh] md:h-screen bg-gray-100 dark:bg-gray-900 overflow-hidden">
      {/* --- Barra superior (apenas celular) --- */}
      <div className="md:hidden flex items-center gap-1 px-2 h-[56px] flex-shrink-0 bg-[#f0f2f5] dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700">
        <Button
          variant="ghost"
          size="icon"
          className="dark:text-gray-400 flex-shrink-0"
          aria-label={sidebarCollapsed ? 'Expandir menu' : 'Recolher menu'}
          onClick={() => setSidebarCollapsed((prev) => !prev)}
        >
          <AlignJustify className="h-5 w-5" />
        </Button>
        {user?.role !== 'SuperAdmin' ? (
          <Button
            variant="ghost"
            size="icon"
            className="dark:text-gray-400 flex-shrink-0"
            aria-label="Voltar"
            onClick={() => navigate('/dashboard')}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
        ) : null}
        <h3 className="flex-1 min-w-0 truncate text-lg font-medium dark:text-gray-200 pl-1">
          {activeTab?.label || (user?.role === 'SuperAdmin' ? t('settings.superAdminPanel') : t('header.settings'))}
        </h3>
        <Header titulo="" user={user} variant="mobile" className="flex-shrink-0" />
      </div>

      <div className="relative flex flex-1 min-h-0 min-w-0">
        {/* Fundo escurecido: no celular o menu expandido fica por cima do conteúdo */}
        {!collapsed && (
          <div
            className="md:hidden absolute inset-0 z-30 bg-black/50"
            onClick={() => setSidebarCollapsed(true)}
            aria-hidden="true"
          />
        )}

        {/* Reserva o espaço do menu recolhido no celular enquanto o menu expandido está sobreposto */}
        <div className={`relative flex-shrink-0 md:contents ${collapsed ? '' : 'w-14'}`}>
          <TooltipProvider delayDuration={100}>
            {/* --- Barra Lateral --- */}
            <aside
              className={`transition-all duration-300 flex flex-col h-full min-h-0 bg-white dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 ${collapsed
                ? "w-14 md:w-[80px] md:min-w-[80px] md:max-w-[80px]"
                : "absolute inset-y-0 left-0 z-40 w-[85vw] max-w-[320px] shadow-xl md:static md:z-auto md:shadow-none md:w-[30%] md:max-w-[420px] md:min-w-[300px]"
                }`}
            >
              {/* Cabeçalho da Barra Lateral (desktop/tablet) */}
              <header className="hidden md:flex bg-[#f0f2f5] dark:bg-slate-800 p-3 h-[60px] items-center justify-between border-b border-gray-200 dark:border-slate-700 flex-shrink-0">
                {/* Avatar (Link para Perfil) */}
                {user?.role !== 'SuperAdmin' ? (
                  <Button
                    variant="ghost"
                    className="dark:text-gray-400"
                    onClick={() => navigate('/dashboard')}
                  >
                    <ArrowLeft className="h-6 w-6" />
                  </Button>
                ) : (
                  !collapsed && <h3 className="text-lg font-medium dark:text-gray-200">{t('settings.superAdminPanel')}</h3>
                )}
              </header>

              <div
                className={`transition-all duration-300 p-4 bg-[#f0f2f5] dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700 flex-shrink-0 ${collapsed
                  ? "opacity-0 pointer-events-none hidden"
                  : "opacity-100 pointer-events-auto visible"
                  }`}
              >
                <div className="relative flex items-center">
                  <Input
                    type="text"
                    placeholder={t('settings.searchPlaceholder')}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full bg-white dark:bg-slate-700 rounded-lg pl-10 pr-4 py-1.5 h-10 md:h-9 text-base md:text-sm border-transparent focus:border-transparent focus:ring-0"
                  />
                  <Search size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-gray-400" />
                </div>
              </div>

              {/* Abas de Filtro */}
              <ul className="list-none p-0 m-0 flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
                {filteredCategories.map((category) => (
                  <li key={category.id} className={`flex flex-col h-auto px-4 rounded-none bg-white dark:bg-slate-900 font-semibold text-${category.color}-700 dark:text-${category.color}-400 shadow`}>
                    <NavTip enabled={collapsed} label={category.label}>
                      <div
                        className="flex jusitfy-between items-center w-full border-b border-gray-200 dark:border-slate-700 cursor-pointer"
                        aria-label={category.label}
                        onClick={() => setExpanded(expanded ? (expanded == category.id ? null : category.id) : category.id)}
                      >
                        <div className={`transition-all duration-200 flex items-center gap-2 w-full h-12 md:h-10 ${collapsed ? 'justify-center' : 'justify-start'}`}>
                          <category.icon className="flex-shrink-0" />
                          {!collapsed ? <span>{category.label}</span> : null}
                        </div>
                        {collapsed ? null : (
                          <ChevronRight
                            size={16}
                            className={`flex-shrink-0 transition-transform duration-200 ${expanded === category.id ? 'rotate-90' : ''}`}
                          />
                        )}
                      </div>
                    </NavTip>

                    <ul className={`transition-all duration-200 list-none p-0 m-0 w-full  ${expanded !== category.id ? 'h-0 overflow-hidden' : 'h-auto'}`}
                    >
                      {category.subcategories.map((subcategory: any) => (
                        <NavTip key={subcategory.id} enabled={collapsed} label={subcategory.label}>
                          <li
                            onClick={() => handleSelect(subcategory as CategoryItem)}
                            aria-label={subcategory.label}
                            className={`text-sm rounded-none relative h-12 md:h-10 transition-colors w-full cursor-pointer flex items-center hover:bg-gray-100 dark:hover:bg-slate-800 ${collapsed ? 'justify-center' : 'pl-2'}
                              ${activeTab?.id === subcategory.id
                                ? `bg-white dark:bg-slate-900 font-semibold text-[${subcategory.color}]-700 dark:text-[${subcategory.color}]-400 shadow`
                                : `text-gray-600 dark:text-gray-300`
                              }`}
                          >
                            {!collapsed ?
                              <div className="flex items-center gap-2 w-full h-12 md:h-10 pl-2 min-w-0">
                                <subcategory.icon className="flex-shrink-0" />
                                <span className="truncate">{subcategory.label}</span>
                              </div>
                              : <subcategory.icon />}
                          </li>
                        </NavTip>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </aside>
          </TooltipProvider>
        </div>

        {/* --- Área Principal (Placeholder ou Rota Aninhada) --- */}
        <main className="flex flex-1 min-w-0 min-h-0 flex-col bg-[#f0f2f5] dark:bg-slate-900 border-l border-gray-200 dark:border-slate-700">
          {/* Header Fixo (desktop/tablet); no celular a barra superior assume esse papel */}
          <div className="hidden md:block flex-shrink-0">
            <Header titulo={t('header.settings')} user={user} sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
          </div>
          <div className="flex-1 min-h-0 min-w-0">
            <FormConfiguracoes
              empresaId="current"
              category={activeTab}
            />
          </div>
        </main>
      </div>
    </div>
  );
};

const NavTip: React.FC<{ enabled: boolean; label: string; children: React.ReactElement }> = ({ enabled, label, children }) =>
  enabled ? (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="right">{label}</TooltipContent>
    </Tooltip>
  ) : (
    children
  );

export default Configuracoes;
